import { GlobeIcon } from "lucide-react";

import { cn } from "@/lib/utils";

export function SiteIcon({ src, className }: { src: string; className?: string }) {
  if (!src) {
    return <GlobeIcon className={cn("size-4 shrink-0", className)} aria-hidden />;
  }

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={src}
      alt=""
      aria-hidden
      className={cn(
        "h-4 w-auto max-w-8 shrink-0 rounded-[2px] object-contain ring-1 ring-foreground/10",
        className,
      )}
    />
  );
}
